module.exports = __webpack_public_path__ + "static/media/TMC_033_Editable_Golf_Club_Flyer_Golfer.49213693.pdf";